import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import dispatcherListingUserPermissionDefinition from "./dispatcher-listing-user-permission";

const useDispatcherListingUserPermissions = () => {
  return useUserPermissions(dispatcherListingUserPermissionDefinition);
};

export default useDispatcherListingUserPermissions;
